import { Box, Button, InputBase } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';

import { useSxStyles } from './useStyles';

type PropsType = {
  showResults?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  openBox?: () => void;
  isBoxOpen: boolean;
};

export const SearchFooterComponent = (props: PropsType) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const { showResults, isBoxOpen, openBox } = props;

  return (
    <>
      <Button
        onClick={openBox}
        sx={{
          ...sxStyles.allEmployeesIcon,
          ...(isBoxOpen ? sxStyles.allEmployeesBoxOpen : {}),
        }}
      >
        <LegacyFAIcon
          FAIcon={LegacyFAIcons.Users}
          title={t('laAllEmployees')}
        />
      </Button>
      <Box sx={sxStyles.infoBoxElementTextBtn}>
        <InputBase
          type="text"
          placeholder={t('laSearchNameIdPosition')}
          onChange={showResults}
          data-id="searchInput"
          sx={{
            ...sxStyles.infoBoxElementText,
            ...sxStyles.infoBoxElementTextInput,
            ...sxStyles.infoBoxElementTextFullWidth,
          }}
        />
        <Box component={'span'} sx={sxStyles.searchIcon}>
          <LegacyFAIcon FAIcon={LegacyFAIcons.Search} />
        </Box>
      </Box>
    </>
  );
};
